import { useState } from "react";

export const useProfileEdit = ({
  profile,
  createProfile,
  updateProfile,
  cancelEditing,
  close,
}) => {
  const [title, setTitle] = useState(profile?.title);
  const [description, setDescription] = useState(profile?.description);
  const [inputType, setInputType] = useState(profile?.inputType);
  const [boundTo, setBoundTo] = useState(profile?.boundTo);
  const [displayRule, setDisplayRule] = useState(profile?.displayRule || 'always');

  const onReset = () => {
    setTitle(profile?.title)
    setDescription(profile.description);
    setInputType(profile?.inputType);
    setBoundTo(profile?.boundTo);
    setDisplayRule(profile?.displayRule || 'always');
  };

  const create = () => {
    if (!profile.id) {
      createProfile({
        id: profile.id,
        title,
        description,
        inputType,
        boundTo,
        displayRule,
      });
    } else {
      updateProfile(profile.id, {
        ...profile,
        title,
        description,
        inputType,
        boundTo,
        displayRule,
      });
    }
  };

  const cancel = () => {
    if (profile?.id) {
      onReset();
      cancelEditing();
      return;
    }
    close();
  };
  return {
    save: create,
    cancel: cancel,
    id: profile?.id,
    title: {
      value: title,
      update: (value) => setTitle(value.target.value),
    },
    description: {
      value: description,
      update: (value) => setDescription(value.target.value),
    },
    inputType: {
      value: inputType,
      update: (value) => setInputType(value),
    },
    boundTo: {
      value: boundTo || [],
      update: (value) => setBoundTo(value),
    },
    displayRule: {
      value: displayRule,
      update: (value) => setDisplayRule(value),
    }
  };
};
